import { SchemaButton, SchemaButtonGroup } from '../types/json-schema.d'
import { SchemaModule } from './module';
import { SchemaModuleGynaecology } from './module-gynaecology';
import { SchemaModuleObstetrics } from './module-obstetrics';
import { SchemaModuleColposcopy } from './module-colposcopy';
import { SchemaModuleCancerUterine } from './module-cancer-uterine';
import { SchemaModuleSurgeryGeneral } from './module-surgery-general';
import { SchemaModuleSurgerySpinal } from './module-surgery-spinal';
import { SchemaModuleCancerCervical } from './module-cancer-cervical';
import { SchemaModuleBreastEndocrineSurgery } from './module-breast-endocrine-surgery';
import { SchemaModuleCardiacSurgery } from './module-cardiac-surgery';
import { SchemaModuleCardiology } from './module-cardiology';
import { SchemaModuleColorectalSurgery } from './module-colorectal-surgery';
import { SchemaModuleGeneralPractice } from './module-general-practice';
import { SchemaModuleHepatobiliarySurgery } from './module-hepatobiliary-surgery';
import { SchemaModuleNeurosurgery } from './module-neurosurgery';
import { SchemaModuleOralMaxillofacialSurgery } from './module-oral-maxillofacial-surgery';
import { SchemaModuleOrthopaedicSurgery } from './module-orthopaedic-surgery';
import { SchemaModuleOtolaryngealSurgery } from './module-otolaryngeal-surgery';
import { SchemaModulePlasticSurgery } from './module-plastic-surgery';
import { SchemaModuleThoracicSurgery } from './module-thoracic-surgery';
import { SchemaModuleTransplantSurgery } from './module-transplant-surgery';
import { SchemaModuleUpperGiSurgery } from './module-upper-gi-surgery';
import { SchemaModuleUrology } from './module-urology';
import { SchemaModuleVascularSurgery } from './module-vascular-surgery';
import { SchemaModuleBariatric } from './module-bariatric';
import { SchemaModuleOpthalmology } from './module-opthalmology';
import { SchemaModulePainManagement } from './module-pain-management';
import { SchemaModuleCancerVulval } from './module-cancer-vulval';
import { SchemaModuleCancerOvarian } from './module-cancer-ovarian';
// hygen placeholder - imports end

const schemaModules = {
  'module-gynaecology': SchemaModuleGynaecology,
  'module-obstetrics': SchemaModuleObstetrics,
  'module-colposcopy': SchemaModuleColposcopy,
  'module-cancer-uterine': SchemaModuleCancerUterine,
  'module-surgery-general': SchemaModuleSurgeryGeneral,
  'module-surgery-spinal': SchemaModuleSurgerySpinal,
  'module-cancer-cervical': SchemaModuleCancerCervical,
  'module-breast-endocrine-surgery': SchemaModuleBreastEndocrineSurgery,
  'module-cardiac-surgery': SchemaModuleCardiacSurgery,
  'module-cardiology': SchemaModuleCardiology,
  'module-colorectal-surgery': SchemaModuleColorectalSurgery,
  'module-general-practice': SchemaModuleGeneralPractice,
  'module-hepatobiliary-surgery': SchemaModuleHepatobiliarySurgery,
  'module-neurosurgery': SchemaModuleNeurosurgery,
  'module-oral-maxillofacial-surgery': SchemaModuleOralMaxillofacialSurgery,
  'module-orthopaedic-surgery': SchemaModuleOrthopaedicSurgery,
  'module-otolaryngeal-surgery': SchemaModuleOtolaryngealSurgery,
  'module-plastic-surgery': SchemaModulePlasticSurgery,
  'module-thoracic-surgery': SchemaModuleThoracicSurgery,
  'module-transplant-surgery': SchemaModuleTransplantSurgery,
  'module-upper-gi-surgery': SchemaModuleUpperGiSurgery,
  'module-urology': SchemaModuleUrology,
  'module-vascular-surgery': SchemaModuleVascularSurgery,
  'module-bariatric': SchemaModuleBariatric,
  'module-opthalmology': SchemaModuleOpthalmology,
  'module-pain-management': SchemaModulePainManagement,
  'module-cancer-vulval': SchemaModuleCancerVulval,
  'module-cancer-ovarian': SchemaModuleCancerOvarian,
  // hygen placeholder - constructors end
};

export function loadSchemaModule<T extends SchemaModule>( key: string ) {
  return new schemaModules[ key ]() as T;
}

export function isSchemaButtonGroup( value: SchemaButton | SchemaButtonGroup ): value is SchemaButtonGroup {
  return 'buttons' in value;
}

export function isArray<T>( value: T | Array<T> ): value is Array<T> {
  return Array.isArray( value );
}



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/forms/schemas.ts